import { EntityId } from 'entities-next/common'

export const DASHBOARD_PATH = '/dashboard'
export const DEAL_MANAGER_PATH = DASHBOARD_PATH + '/admin/deals'
export const ORGANIZATION_MANAGER_PATH = DASHBOARD_PATH + '/admin/organizations'
export const PEOPLE_MANAGER_PATH = DASHBOARD_PATH + '/admin/people'
export const LOGOUT_PATH = DASHBOARD_PATH + '/logout'

export function getOrganizationPath(organizationId: EntityId) {
  return ORGANIZATION_MANAGER_PATH.concat(`?search=${organizationId}`)
}
